import { render } from "./create-customer.vue?vue&type=template&id=73bb3a65"
import script from "./create-customer.vue?vue&type=script&lang=js"
export * from "./create-customer.vue?vue&type=script&lang=js"

import "./create-customer.vue?vue&type=style&index=0&id=73bb3a65&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__